<template>
    <div>
        <img data-smiles="OC(C(=O)O[C@H]1C[N+]2(CCCOC3=CC=CC=C3)CCC1CC2)(C1=CC=CS1)C1=CC=CS1"
             data-smiles-options="{ 'width': 800, 'height': 800 }" />
<!--        <svg data-smiles="C=CCBr.[Na+].[I-]>CC(=O)C>C=CCI.[Na+].[Br-]  __{'textBelowArrow': '90%'}__" />-->
    </div>
</template>
<script>
    export default {
        methods:{
            draw()
            {
                SmiDrawer.apply();
            //
            }
        },
        mounted() {
            this.draw()
        }
    }
</script>
